/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Geocollapse1Inputs */

const en_geocollapse1 = /** @type {(inputs: Geocollapse1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minimize map`)
};

const de_geocollapse1 = /** @type {(inputs: Geocollapse1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Karte verkleinern`)
};

/**
* | output |
* | --- |
* | "Minimize map" |
*
* @param {Geocollapse1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const geocollapse1 = /** @type {((inputs?: Geocollapse1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geocollapse1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_geocollapse1(inputs)
	return de_geocollapse1(inputs)
});
export { geocollapse1 as "geoCollapse" }